import { motion } from 'framer-motion';

export const AtAGlanceTable = ({ items, sectionLabel = 'Quick Reference', title = 'At a Glance' }) => (
  <section className="py-20 md:py-32 bg-[#F1F5F8]">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="text-center mb-12">
        <p className="text-sm font-medium uppercase tracking-widest text-[#163A59] mb-4">
          {sectionLabel}
        </p>
        <h2 className="font-['Source_Serif_4'] text-3xl md:text-4xl font-semibold text-slate-900">
          {title}
        </h2>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="bg-white border border-slate-200 overflow-hidden max-w-4xl mx-auto"
      >
        {items.map((item, index) => (
          <div
            key={item.label}
            className={`grid md:grid-cols-3 ${index !== items.length - 1 ? 'border-b border-slate-200' : ''}`}
          >
            <div className="bg-[#F1F5F8] px-6 py-4 font-medium text-slate-900">
              {item.label}
            </div>
            <div className="md:col-span-2 px-6 py-4 text-slate-600">
              {item.value}
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  </section>
);
